/* istanbul ignore file */
export default ({ palette }) => ({
  offBackground: palette.text.midGray,
  onBackground: palette.primary.normal,
  disabledBackground: '#ededed'
});
